import { styled } from '@olxeu-jobs/ui';

export const StyledTile = styled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: `${$theme.space[12]} ${$theme.space[8]}`,
  border: `1px solid ${$theme.colors['borders-global-tertiary']}`,
  borderRadius: $theme.radii[4],
  backgroundColor: $theme.colors['background-global-primary'],
}));
